import { ModelSnippetFn } from '../types';

export const text: ModelSnippetFn = (props) => `
# Model version ID is optional. It defaults to the latest model version, if omitted

curl -X POST "${props.apiHost}/v2/users/${props.userId}/apps/${props.appId}/models/${props.modelId}/versions/${props.modelVersionId}/outputs" \
  -H "Authorization: Key ${props.pat}" \
  -H "Content-Type: application/json" \
  -d '{
    "inputs": [
      {
        "data": {
          "text": {
            "raw": "I love your product very much"
          }
        }
      }
    ]
  }'
`;

export const image: ModelSnippetFn = (props) => `
# Model version ID is optional. It defaults to the latest model version, if omitted

curl -X POST "${props.apiHost}/v2/users/${props.userId}/apps/${props.appId}/models/${props.modelId}/versions/${props.modelVersionId}/outputs" \
  -H "Authorization: Key ${props.pat}" \
  -H "Content-Type: application/json" \
  -d '{
    "inputs": [
      {
        "data": {
          "image": {
            "url": "${props.inputUrl}"
          }
        }
      }
    ]
  }'
`;

export const audio: ModelSnippetFn = (props) => `
# Model version ID is optional. It defaults to the latest model version, if omitted

curl -X POST "${props.apiHost}/v2/users/${props.userId}/apps/${props.appId}/models/${props.modelId}/versions/${props.modelVersionId}/outputs" \
  -H "authorization: Key ${props.pat}" \
  -H "content-type: application/json" \
  -d '{
    "inputs": [
        {
          "data": {
            "audio": {
              "url": "${props.inputUrl}"
          }
        }
      }
    ]
}'
`;

export const video: ModelSnippetFn = (props) => `
# Model version ID is optional. It defaults to the latest model version, if omitted

curl -X POST "${props.apiHost}/v2/users/${props.userId}/apps/${props.appId}/models/${props.modelId}/versions/${props.modelVersionId}/outputs" \
  -H "Authorization: Key ${props.pat}" \
  -H "Content-Type: application/json" \
  -d '{
    "inputs": [
      {
        "data": {
          "video": {
            "url": "${props.inputUrl}"
          }
        }
      }
    ]
  }'
`;
